var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-modal-container"},[_c('Layouts',{attrs:{"initial-data":_vm.initialData},on:{"close":_vm.onClose,"addFrame":_vm.onAddFrame}}),_c('div',{staticClass:"layout-modal-legend",style:({ right: _vm.right })})],1)}
var staticRenderFns = []

export { render, staticRenderFns }